import {svgIconWrapper} from '../svg-icon-wrapper';

import ClaudeRegularAi from './claude-regular-ai-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <ClaudeRegularAi {...props} />;
}

SvgComponent.iconName = 'claudeRegularAi';

export const ClaudeRegularAiIcon = svgIconWrapper(SvgComponent);
